class EmojiDecoder {
    emojiMap:any = new Map();
    url = "";
    patterns = [] as any;
    metaChars = /[[\]{}()*+?.\\|^$\-,&#\s]/g;

    constructor(url:any,emojiList:any) {
        this.url = url || '';
        emojiList.forEach((el:any) => {
            this.emojiMap.set(el.title,el.url)
        });
        this.emojiMap.forEach((val:any,key:any) => {
            this.patterns.push('('+key.replace(this.metaChars, "\\$&")+')');
        })
    }

    decode (text:any) {
        if (!text) return '';
        return text.replace(new RegExp(this.patterns.join('|'),'g'),  (match:any) => {
            return typeof this.emojiMap.get(match) != 'undefined' ? '<img height="25px" width="25px" class="msg-emoji" src="'+this.url+this.emojiMap.get(match)+'" />' : match;
        });
    }
}

export default EmojiDecoder
